// Update the import path if the file was moved or renamed
import PortfolioLocations from '../navPages/PortfolioLocations' // _NEW
import PortfolioNotes from '../navPages/PortfolioNotes'
import PortfolioChat from '../navPages/PortfolioChat'
import PortfolioTasksCN from '../navPages/PortfolioTasksCN'
import PortfolioImagesCN from '../navPages/PortfolioImagesCN'
import PortfolioDocumentsCN from '../navPages/PortfolioDocumentsCN'
import PortfolioFinancials from '../navPages/PortfolioFinancials'
import PortfolioReports from '../navPages/PortfolioReports'
import PortfolioEdit from '../navPages/PortfolioEdit'
import PortfolioAddLocations from '../navPages/PortfolioAddLocations'
import PortfolioPartners from '../navPages/PortfolioPartners'
import {
	MapPin,
	StickyNote,
	MessageSquare,
	ListTodo,
	Images,
	FileText,
	DollarSign,
	FileBarChart,
	Handshake,
} from 'lucide-react'
import routes from 'constants/routes'
import type { Capabilities } from '../../../utils/capabilities'

const getPortfolioRoutes = (id: string, capabilities?: Capabilities) => [
	{
		linkText: 'Locations',
		linkTo: `${routes.PORTFOLIOS}/${id}/locations`,
		linkPattern: `${routes.PORTFOLIOS}/:id/locations`,
		icon: MapPin,
		component: PortfolioLocations,
	},
	{
		linkText: 'Tasks',
		linkTo: `${routes.PORTFOLIOS}/${id}/tasks`,
		linkPattern: `${routes.PORTFOLIOS}/:id/tasks`,
		icon: ListTodo,
		component: PortfolioTasksCN,
	},
	{
		linkText: 'Notes',
		linkTo: `${routes.PORTFOLIOS}/${id}/notes`,
		linkPattern: `${routes.PORTFOLIOS}/:id/notes`,
		icon: StickyNote,
		component: PortfolioNotes,
	},
	{
		linkText: 'Chat',
		linkTo: `${routes.PORTFOLIOS}/${id}/chat`,
		linkPattern: `${routes.PORTFOLIOS}/:id/chat`,
		icon: MessageSquare,
		component: PortfolioChat,
	},
	{
		linkText: 'Financials',
		linkTo: `${routes.PORTFOLIOS}/${id}/financials`,
		linkPattern: `${routes.PORTFOLIOS}/:id/financials`,
		icon: DollarSign,
		component: PortfolioFinancials,
	},
	{
		linkText: 'Images',
		linkTo: `${routes.PORTFOLIOS}/${id}/images`,
		linkPattern: `${routes.PORTFOLIOS}/:id/images`,
		icon: Images,
		component: PortfolioImagesCN,
	},
	{
		linkText: 'Documents',
		linkTo: `${routes.PORTFOLIOS}/${id}/files`,
		linkPattern: `${routes.PORTFOLIOS}/:id/files`,
		icon: FileText,
		component: PortfolioDocumentsCN,
	},
	{
		linkText: 'Partners',
		linkTo: `${routes.PORTFOLIOS}/${id}/partners`,
		linkPattern: `${routes.PORTFOLIOS}/:id/partners`,
		icon: Handshake,
		component: PortfolioPartners,
	},
	{
		linkText: 'Reports',
		linkTo: `${routes.PORTFOLIOS}/${id}/reports`,
		linkPattern: `${routes.PORTFOLIOS}/:id/reports`,
		icon: FileBarChart,
		component: PortfolioReports,
	},
	/*
		Removing linkText and/or linkTo removes link from sub nav but creates a route
	*/
	{
		linkPattern: `${routes.PORTFOLIOS}/:id/edit`,
		component: PortfolioEdit,
	},
	{
		linkPattern: `${routes.PORTFOLIOS}/:id/addlocations`,
		component: PortfolioAddLocations,
	},
	/*
		Redirect routes
	*/
	{
		redirectFrom: `${routes.PORTFOLIOS}/:id`,
		redirectTo: `${routes.PORTFOLIOS}/${id}/locations`,
	},
	// Hide the Financials tab from accounts without financials access
	// (community). Omitting `capabilities` shows everything (pro default).
].filter((route: any) => {
	if (route.linkText === 'Financials' && capabilities && !capabilities.canSeeFinancials) {
		return false
	}
	return true
})

export default getPortfolioRoutes
